import { getDefaultMessages } from '@/bundles/Localization/messages';

export const i18nConfig = {
  locale: 'en',
  messages: {
    en: getDefaultMessages()
  }
};
